<template>
  <div class="app-esim-qr-code content-width">
    <h3 class="text-3xl">QR-Code</h3>
    <div class="mb-4">
        <p>
          Scanne den Code mit deinem Smartphone ab und folge dem Assistenten zum Einrichten.
        </p>
        <p>
          Hier findest du eine Erklärung für iOS und Android Geräte:<br />
          <a
            href="files/lidl/downloads/LIDL_Connect_eSIM_Anleitung_QR-Code_iOS.pdf"
            target="_blank"
            rel="noopener"
          >Anleitung für iOS</a><br />
          <a
            href="files/lidl/downloads/LIDL_Connect_eSIM_Anleitung_QR-Code_Android.pdf"
            target="_blank"
            rel="noopener"
          >Anleitung für Android</a>
        </p>
      <img class="qr-code" :src="'data:image/png;base64,' + qrCode" alt="eSIM SetUp QR-Code" />
    </div>

    <div class="input-field">
      <label class="text-base-medium">Bestätigungscode (ePIN):</label>
      <input class="input" :type="fieldType" :value="ePin" required readonly autocomplete="off" @input="() => false"/>
      <button @click="toggleEPin()" type="button" class="btn btn-primary copy-btn">
        <img v-if="!showEPin" src='/files/lidl/images/new-icons/svg/eye-outline.svg'>
        <img v-if="showEPin" src='/files/lidl/images/new-icons/svg/eye-slash.svg'>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ESimQRCode',
  props: {
    qrCode: {
      type: String,
      default: ''
    },
    ePin: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fieldType: 'password',
      showEPin: false
    }
  },
  methods: {
    toggleEPin() {
      this.showEPin = !this.showEPin
      this.fieldType = this.showEPin ? 'text' : 'password'
    }
  }
}
</script>
